import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useTravelPageRollout() {
  return useCbhFlag(CbhFeatureFlag.TRAVEL_PAGE_ROLLOUT, {
    defaultValue: {
      enabled: false,
      maxDistanceMiles: 3000,
      pageSize: 100,
      travelPageUrl: "",
      iconName: "airplane-takeoff",
    },
  });
}
